import { Injectable } from '@angular/core';
import { Subject, Observable, BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

export enum RefreshContext {
  DepartureModal = 'departureModal',
  DestinationModal = 'destinationModal',
  General = 'general'
}

export interface RefreshEvent {
  context?: RefreshContext;
  timestamp: number;
}

export class RefreshTrigger {
  private triggerSubject = new Subject<RefreshEvent>();
  private loadingSubject = new BehaviorSubject<RefreshContext | null>(null);

  refresh(context?: RefreshContext): void {
    this.triggerSubject.next({
      context: context || RefreshContext.General,
      timestamp: Date.now()
    });
  }

  getTrigger(): Observable<RefreshEvent> {
    return this.triggerSubject.asObservable();
  }

  setLoading(context: RefreshContext | null): void {
    this.loadingSubject.next(context);
  }

  getLoading(): Observable<RefreshContext | null> {
    return this.loadingSubject.asObservable();
  }

  isLoading(context: RefreshContext): Observable<boolean> {
    return this.loadingSubject.pipe(
      map(current => current === context)
    );
  }
}

@Injectable({
  providedIn: 'root'
})
export class RefreshService {
  createRefreshTrigger(): RefreshTrigger {
    return new RefreshTrigger();
  }
}
